<template>
  <div></div>
</template>

<script>
export default {
  name: "sign",
  created() {
    document.title = '用户签到 - JapanHui';
  },
}
</script>

<style scoped>

</style>